export default {
    name: 'A5',
    lineHeight: '20px',
    lineHeightDesktop: '40px',
  }